export interface ISystemDetails {
    systemGuid: string;
    systemType: string;
    systemId: string;
    ownershipCode: string;
    user: string;
}

export class SystemDetails implements ISystemDetails {
    systemGuid: string;
    systemType: string;
    systemId: string;
    ownershipCode: string;
    user: string;

    constructor(systemGuid: string,
        systemType: string,
        systemId: string,
        ownershipCode: string,
        user: string) {
        this.systemGuid = systemGuid;
        this.systemId = systemId;
        this.systemType = systemType;
        this.ownershipCode = ownershipCode;
        this.user = user;
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/systemDetailsRetriever/system-details.ts
 **/